// WHAT CAN BE CHANGED
// Change button-send.svg to whatever style you want
// You can also make style changes accordingly below

<template>
    <div id="chatInput" v-bind:class="{ previewActive: fileChosen }">
        <div id="chatInput__container">
            <svg-icon
                icon="paperclip"
                fill="#959694"
                height="22px"
                width="22px"
                id="chatInput__container__paperclip"
                v-on:click="showPicker = true"
            />
            <input id="chatInput__container__input" type="text" placeholder="Typ hier je bericht" autocomplete="off" required v-model="message" @focus="setKeyboardActive" @blur="setKeyboardSedentary">
            <button id="chatInput__container__button" v-on:click="sendMessage()"></button>
        </div>
        <ProgressBar hint="Je bestand wordt verstuurd..." :percentage="uploadPercentage" v-if="uploadPercentage !== 0 && uploadPercentage !== 100"/>
        <AttachmentPicker v-if="showPicker" @filePicked="setPreviewer"/>
        <FilePreviewer v-if="fileChosen" v-bind:content="fileChosen" @closePreview="fileChosen = null"/>
    </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue';
import ProgressBar from '@/components/ProgressBar.vue';
import AttachmentPicker from '@/components/AttachmentPicker.vue';
import FilePreviewer from '@/components/FilePreviewer.vue';
import db from "@/firebase/firebaseInit";

export default {
    name: "chatInput",
    components: {
        SvgIcon,
        ProgressBar,
        AttachmentPicker,
        FilePreviewer
    },
    props: {
        chatboxMessages: {
            type: Array,
            required: true
        },
        userData: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            message: null,
            showPicker: false,
            fileChosen: null,
            uploadPercentage: 0
        }
    },
    created() {
        window.addEventListener('click', (e) => {
            if (!this.$el.contains(e.target)){
                this.showPicker = false;
            }
        })
    },
    methods: {
        setPreviewer(value) {
            this.fileChosen = value.target.files[0];
        },
        setKeyboardActive() {
            this.showPicker = false;
            setTimeout(() => {
                document.getElementById("chatInput").style.bottom = "0px";
                document.body.classList.add("when-keyboard-active");
                document.getElementById("message").classList.add("keyboard-space");
            }, 100)
        },
        setKeyboardSedentary() {
            setTimeout(() => {
                document.getElementById("chatInput").style.bottom = "114px";
                document.body.classList.remove("when-keyboard-active");
                document.getElementById("message").classList.remove("keyboard-space")
            }, 100);
        },
        clearInput() {
            this.message = "";
        },
        async sendMessage() {
            this.showPicker = false;
            if(this.fileChosen) {
                let file = this.fileChosen;
                this.fileChosen = null;
                await this.uploadFile(file);
                db.firestore()
                    .collection("messages")
                    .add({
                        user: this.userData[0].username,
                        message: file.name,
                        isFile: true,
                        uid: this.userData[0].uid,
                        phoneNumber: this.userData[0].phone,
                        time: new Date().toLocaleTimeString("en-US", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                        }),
                        day: new Date().getDate(),
                        month: new Date().getMonth() + 1,
                        fileMessage: document.getElementById("chatInput__container__input").value,
                        fileURL: file.fileURL
                    });
                this.$props.chatboxMessages.push({
                    user: this.userData[0].username,
                    message: file.name,
                    isFile: true,
                    time: new Date().toLocaleTimeString("en-US", {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                    }),
                    fileMessage: document.getElementById("chatInput__container__input").value,
                    fileURL: file.fileURL
                });
                sessionStorage.setItem("data", JSON.stringify(this.$props.chatboxMessages));
                this.clearInput();
                // this.fileChosen = null;
                // console.log(this.$props.chatboxMessages);
                setTimeout(() => {
                    window.scrollTo(0, document.body.scrollHeight);
                }, 100);
            } else {
            if(document.getElementById("chatInput__container__input").value !== "") {
                await db.firestore()
                .collection("messages")
                .add({
                    user: this.userData[0].username,
                    message: this.message,
                    isFile: false,
                    uid: this.userData[0].uid,
                    phoneNumber: this.userData[0].phone,
                    time: new Date().toLocaleTimeString("en-US", {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                    }),
                    day: new Date().getDate().toString(),
                    month: (new Date().getMonth() + 1).toString(),
                });
                this.$props.chatboxMessages.push({
                    message: this.message,
                    isFile: false,
                    time: new Date().toLocaleTimeString("en-US", {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                    }),
                });
                sessionStorage.setItem("data", JSON.stringify(this.$props.chatboxMessages));
                this.clearInput();
                setTimeout(() => {
                    window.scrollTo(0, document.body.scrollHeight);
                }, 100);
            }
            }
        },
        async uploadFile(file) {
            return new Promise((resolve, reject) => {
                console.log("Uploading file ...");
                const storageRef = db.storage().ref(`${file.name}`);
                const uploadTask = storageRef.put(file);

                uploadTask.on(`state_changed`,
                (snapshot) => {
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    this.uploadPercentage = progress;
                    this.showPicker = false;
                },
                (error) => {
                    console.log(error);
                    reject(error);
                },
                async () => {
                    const fileURL = await uploadTask.snapshot.ref.getDownloadURL();
                    console.log("Uploaded file: " + fileURL);
                    file.fileURL = fileURL;
                    resolve();
                })
            });
        },
    }
};
</script>

<style lang="scss" scoped>
.previewActive {
    bottom: 0px !important;
    input {
        color: white !important;
    }
}

input:focus, textarea:focus, select:focus{
    outline: none;
}

#chatInput {
    height: 73px;
    width: 100%;
    background-color: #f1f1f1;
    box-shadow: 0 -3px 6px -2px rgba(0, 0, 0, 0.2);
    position: fixed;
    left: 0;
    bottom: 114px;
    z-index: 998;
    
    #chatInput__container {
        padding: 0px 16px;
        margin: auto;
        margin-top: 12px;
        max-width: 736px;
        position: relative;
        z-index: 999;

        #chatInput__container__paperclip {
            padding: 11px 0px 0px 31px;
            position: absolute;
            display: block;
            left: 0;
        }

        #chatInput__container__input {
            width: calc(100% - 54px);
            box-sizing: border-box;
            height: 44px;
            border: 2px solid #959694;
            border-radius: 999px;
            background-color: transparent;
            padding: 0px 16px 0px 46px;
            font-size: 18px;
        }

        #chatInput__container__button {
            appearance: none;
            background: transparent;
            background-image: url(../assets/chat/button-send.svg);
            background-repeat: no-repeat;
            border: none;
            position: absolute;
            right: 16px;
            box-sizing: border-box;
            width: 44px;
            height: 44px;
        }
    }
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
    #chatInput {

    }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
    #chatInput {

    }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px)  {
    #chatInput {

    }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px)  {
    #chatInput {
        bottom: 0px !important;
    }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px)  {
    #chatInput {
       bottom: 0px !important;
    }
}
</style>